export const COMMON_WORDS = {
  words: ['password'],
  pattern: /password/,
};
